module.exports = __webpack_public_path__ + "media/images/icon__reddit-0a56f35ab4beb451ea7934ab84d3b963.png";